import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const InteractiveToggle = (props: any) => {
  const { width } = useWindowSize()

  return (
    <StyledToggel onClick={props.onClick} isActive={props.isActive}>
      <ButtonTitle isActive={props.isActive}>
        {props.isActive ? 'Karte deaktivieren' : 'Interaktive Karte erkunden'}
      </ButtonTitle>
      {!props.isActive && (
        <UIContainer>
          <UITipContainer>
            <img
              alt={
                width > 712
                  ? 'Linke Maustaste halten um die Karte zuverschieben.'
                  : 'Tippen und halten um die Karte zuverschieben.'
              }
              src={
                (width > 712
                  ? require('../../Assets/icons_leftmouse.svg')
                  : require('../../Assets/icons_pointermove.svg')
                ).default
              }
            />
            Karte bewegen
          </UITipContainer>
          <UITipContainer>
            <img
              alt={
                width > 712
                  ? 'Mausrad zum hinein und heraus zoomen'
                  : 'Mit zwei Fingern hinein und heraus zoomen'
              }
              src={
                (width > 712
                  ? require('../../Assets/icons_mousewheel.svg')
                  : require('../../Assets/icons_pinch.svg')
                ).default
              }
            />
            Zoomen
          </UITipContainer>
        </UIContainer>
      )}
    </StyledToggel>
  )
}

const StyledToggel = styled.button<{ isActive: boolean }>`
  position: absolute;
  border-radius: 5px;
  border: 0;
  padding: ${({ isActive }) =>
    !isActive ? '1.5rem 1.5rem 1rem 1.5rem' : '1rem 1.5rem'};
  transition: all 0.3s ease;
  background-color: ${({ isActive }) =>
    isActive ? 'var(--red-main)' : 'var(--brandblue-main)'};
  color: #fff;
  pointer-events: all;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.2px;
  top: ${({ isActive }) => (!isActive ? '50%' : '60px')};
  left: 50%;
  z-index: 1203;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: ${({ isActive }) => (isActive ? undefined : '300px')};
  transform: translate(-50%, -50%);

  -webkit-box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.26),
    0px 0px 10px 5px rgba(255, 255, 255, 0.26);
  box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.26),
    0px 0px 10px 5px rgba(255, 255, 255, 0.26);

  @media only screen and (min-width: 712px) {
    &:hover {
      cursor: pointer;
      background-color: ${({ isActive }) =>
        isActive ? 'var(--red-bright-1)' : 'var(--brandblue-bright-1)'};
    }
  }
  @media only screen and (max-width: 711px) {
    font-size: 13px;
  }
`

const ButtonTitle = styled.div<{ isActive: boolean }>`
  font-size: ${({ isActive }) => (isActive ? '15px' : '18px')};
  font-weight: 700;
  flex: 0 0 90%;
  padding: 10px;
  text-align: center;

  @media only screen and (max-width: 711px) {
    font-size: ${({ isActive }) => (isActive ? '15px' : '18px')};
  }
`
const UIContainer = styled.div`
  flex: 0 0 100%;
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
  gap: 20%;
  justify-content: center;
`

const UITipContainer = styled.div`
  flex: 0 0 25%;
  display: flex;
  flex-wrap: wrap;
  img {
    flex: 0 0 100%;
    max-width: 100%;
  }
  @media only screen and (max-width: 711px) {
    flex: 0 0 20%;
  }
`
